import EventInfo from "../../../../components/sections/front/user-events-collections/EventInfo";
import { useNavigate, useOutletContext } from "react-router-dom";
import CreateAddons from "../../../../components/sections/front/user-tickets/CreateAddons";

const Addons = () => {
  const navigate = useNavigate();
  const { event, eventLoading, selectedLanguage } = useOutletContext();

  if (!event?.data?._id && !eventLoading) {
    navigate(`/${selectedLanguage}/user/events`);
    return;
  }

  return (
    <div className="w-full relative flex items-start gap-6">
      <div className="flex-shrink-0 w-96 top-28 sticky">
        <EventInfo details={event} />
      </div>
      <div className="relative flex-shrink flex-grow">
        <CreateAddons eventDetails={event?.data || {}} />
      </div>
    </div>
  );
};

export default Addons;
